<template lang="pug">
  el-row.justify-center.align-middle
    el-col
      el-card(shadow='hover').card
        .text-center
          p(v-if="dadosDocumento.tipo.codigo === 'ART_TRT'").info Nome do documento: Anotação de Responsabilidade Técnica - ART
          slot(name="baixar")
          el-row.dados-doc.justify-center
            .link-download
              font-awesome-icon(icon="cloud-download-alt")
              a(@click.prevent="downloadDoc(dadosDocumento.id)") &nbsp; Baixar Documento
</template>

<script>
import { mapActions } from 'vuex'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {
  mixins: [
    AppNotificacao
  ],

  created () {
    this.buscarDadosDocumento()
  },

  data () {
    return {
      dadosDocumento: {}
    }
  },

  methods: {
    ...mapActions({
      baixarDocumento: 'documentos/downloadDocumento',
      getDadosDocumento: 'documentos/getDadosDocumento'
    }),

    async buscarDadosDocumento () {
      const payload = {
        tipoDocumento: this.$route.params.tipoDocumento,
        idProcesso: this.$route.params.idProcesso
      }

      try {
        const response = await this.getDadosDocumento(payload)
        this.dadosDocumento = response
      } catch (error) {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Houve um erro ao buscar o arquivo.')
      }
    },

    async downloadDoc (id) {
      await this.baixarDocumento(id)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/_variables.scss";

.card {
  border-radius: 10px;
  padding: 20px;
}

.info {
  font-weight: bold;
  font-size: 16px;
  margin: 10px 0 5px 0;
}

.link-download, a {
  margin-top: 15px;
  color: $color-primary;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    color: #33b281;
  }
}

.text-center {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/DownloadDocumento.vue